import { render, staticRenderFns } from "./footerBottom.vue?vue&type=template&id=11c080f0&scoped=true&"
import script from "./footerBottom.vue?vue&type=script&lang=js&"
export * from "./footerBottom.vue?vue&type=script&lang=js&"
import style0 from "./footerBottom.vue?vue&type=style&index=0&id=11c080f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c080f0",
  null
  
)

export default component.exports